module.exports = __webpack_public_path__ + "img/technology-icon-2.530cd4f8.png";